<template>
    <div class="content">
        <component
            :is="computedComponent(block)"
            v-for="(block, key) in content"
            :key="`block-${key}`"
            v-bind="block"
        />
    </div>
</template>
<script setup>
import { resolveComponent } from '#imports';

defineProps({
    content: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const computedComponent = block => {
    const {
        contentType: type,
        type: subType,
        display: data,
    } = block;
    if (type === 'cardList' && data.component === 'articleList') {
        return resolveComponent('BlocksArticleList');
    }
    if (type === 'cardList' && data.component === 'carwashClinic') {
        return resolveComponent('BlocksCarwashClinic');
    }
    if (type === 'cardList') {
        return resolveComponent('BlocksCardList');
    }
    if (type === 'articleBlock') {
        return resolveComponent('BlocksArticle');
    }
    if (type === 'externalDatasource' && subType === 'stationlocator') {
        return resolveComponent('SLMain');
    }
    if (['externalDatasource', 'stations'].includes(type)) {
        return resolveComponent('BlocksStations');
    }
    if (type === 'formBuilder') {
        return resolveComponent('BlocksFormbuilder');
    }
    if (type === 'listprices') {
        return resolveComponent('BlocksListPrices');
    }

    if (import.meta.dev) {
        return resolveComponent('BlocksDefaultContent');
    }

    return null;
};
</script>
<style scoped>
.content {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  align-items: start;
  width: 100%;
}
</style>
